export default "__VITE_ASSET__ILkGu1JQ__"